import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  BorderedButton,
  UnborderedButton,
} from "../../components/shared/customTable.styled";
import CreditBar from "./components/CreditBar";
import { HeaderBar, HeaderText, CreditBarMobileWrapper } from "./components/creditBar.styled";
import Pen from "../../components/shared/treatedIcons/Pen";
import { RowActionButton, ConfirmAction, CancelAction } from "../../components/shared/table/editableRow.style";
import { CreditInput } from "./employeesTable.styles";
import { selectEmployeeCredit, onUpdateEmployeeCredit } from "./actions/employees";
import { changeEmployeeCredit } from "../customers/register/actions";
import {
  StyledCard,
  StyledCardBody,
  StyledRowMobile,
  StyledTitleMobile,
  StyledLineMobile,
  StyledHr,
  MobileCreditTitleRow,
  MobileCreditEditRow,
  MobileCreditEditActions,
  MobileCreditInputWrap,
  MobileCreditEditButton
} from "./components/styled";
import { BaseColumn } from "@bit/wavfichacerta.fichacerta.shared-styles.columns";

class UsersRow extends Component {
  renderHeaderCredit = (available, used) => (
    <HeaderBar>
      <HeaderText>R$ {available} / R$ {used}</HeaderText>
    </HeaderBar>
  );

  renderBorderedButton = () => {
    const { type, onClickType } = this.props;

    return (
      <BorderedButton onClick={onClickType}>
        {type.toLowerCase()}
      </BorderedButton>
    );
  };

  renderDisabledButton = () => {
    const { type } = this.props;

    return (
      <UnborderedButton disabled={true}>{type.toLowerCase()}</UnborderedButton>
    );
  };

  renderBorderedButtonStatus = () => {
    const { onClickStatus, status } = this.props;

    let colorButton = "";
    switch (status) {
      case "ATIVO":
        colorButton = "color_green";
        break;
      case "SUSPENSO":
        colorButton = "color_systemic_feedback_regular";
        break;
      default:
        colorButton = "color_red";
        break;
    }

    return (
      <BorderedButton onClick={onClickStatus} color={colorButton}>
        {status}
      </BorderedButton>
    );
  };

  renderUnborderedButtonStatus = () => {
    return null;
  };

  onConfirmCredit = e => {
    e.preventDefault();
    const { id, credito, changeEmployeeCredit, selectEmployeeCredit } = this.props;
    changeEmployeeCredit(id, credito);
    selectEmployeeCredit(undefined);
  };

  disableEditMode = e => {
    e.preventDefault();
    const { selectEmployeeCredit, getUsers } = this.props;
    selectEmployeeCredit(undefined);
    getUsers();
  };

  onSelectCreditToEdit = e => {
    e.preventDefault();
    const { selectEmployeeCredit, id } = this.props;
    selectEmployeeCredit(id);
  };

  changeCredit = e => {
    const { value } = e.target;
    const { id, onUpdateEmployeeCredit } = this.props;
    onUpdateEmployeeCredit(id, value);
  };

  renderMobileCreditEditor = () => {
    const { editMode, credito } = this.props;

    return (
      <>
        <MobileCreditEditRow>
          <MobileCreditInputWrap editMode={editMode}>
            <CreditInput
              name="credit"
              type="text"
              value={credito}
              onChange={this.changeCredit}
              disabled={!editMode}
              editMode={editMode}
            />
          </MobileCreditInputWrap>
          {editMode ? (
            <MobileCreditEditActions>
              <RowActionButton onClick={this.onConfirmCredit}>
                <ConfirmAction />
              </RowActionButton>
              <RowActionButton onClick={this.disableEditMode}>
                <CancelAction />
              </RowActionButton>
            </MobileCreditEditActions>
          ) : null}
        </MobileCreditEditRow>
      </>
    );
  };

  render() {
    console.log(this.props.userId, this.props.loggedId);
    const {
      onClickClock,
      nome,
      funcao,
      typeUser,
      credito,
      usedCreditPercentage,
      Icon,
      onClickEdit,
      condicao,
      credito_utilizado,
      credito_disponivel,
      type
    } = this.props;

    let ButtonType;
    let ButtonStatus;

    if (typeUser === "ADICIONAL") {
      ButtonType = this.renderDisabledButton();
      ButtonStatus = this.renderUnborderedButtonStatus();
    } else if (this.props.userId === this.props.loggedId) {
      ButtonType = this.renderBorderedButton();
      ButtonStatus = this.renderUnborderedButtonStatus();
    } else {
      ButtonType = this.renderBorderedButton();
      ButtonStatus = this.renderBorderedButtonStatus();
    }

    return (
      <StyledCard>
        <StyledCardBody>
          <StyledRowMobile>
            <BaseColumn xs="12" sm="12">
              <StyledTitleMobile>Nome</StyledTitleMobile>
              <StyledLineMobile onClick={onClickEdit}>{nome}</StyledLineMobile>
            </BaseColumn>
          </StyledRowMobile>
          <StyledHr />
          <StyledRowMobile>
            <BaseColumn xs="10" sm="10">
              <StyledTitleMobile>Função</StyledTitleMobile>
              <StyledLineMobile>{funcao}</StyledLineMobile>
            </BaseColumn>
            <BaseColumn xs="2" sm="2">
              <StyledLineMobile>
                <Icon
                  onClick={onClickClock}
                  width="2rem"
                  id={nome.replace(/ /g, "_")}
                />
              </StyledLineMobile>
            </BaseColumn>
          </StyledRowMobile>
          <StyledHr />
          <StyledRowMobile>
            <BaseColumn xs="4" sm="4">
              <StyledTitleMobile>Tipo</StyledTitleMobile>
              <StyledLineMobile>{ButtonType}</StyledLineMobile>
            </BaseColumn>
            <BaseColumn xs="4" sm="4">
              <StyledTitleMobile>Status</StyledTitleMobile>
              <StyledLineMobile>{ButtonStatus}</StyledLineMobile>
            </BaseColumn>
            <BaseColumn xs="4" sm="4">
              <StyledTitleMobile>Consumo</StyledTitleMobile>
              <StyledLineMobile>
                {condicao === "POSPAGO" && typeUser === "MASTER" && (
                  <CreditBarMobileWrapper>
                    {this.renderHeaderCredit(
                      credito_disponivel,
                      credito_utilizado
                    )}
                    <CreditBar
                      availableCredit={credito}
                      usagePercentage={usedCreditPercentage}
                    />
                  </CreditBarMobileWrapper>
                )}
              </StyledLineMobile>
            </BaseColumn>
          </StyledRowMobile>
          {(condicao === "POSPAGO" && typeUser === "MASTER" && type !== "MASTER") && (
            <>
              <StyledHr />
              <StyledRowMobile>
                <BaseColumn xs="12" sm="12">
                  <MobileCreditTitleRow>
                    <StyledTitleMobile>Editar limite disponível</StyledTitleMobile>
                    {!this.props.editMode && (
                      <MobileCreditEditButton onClick={this.onSelectCreditToEdit}>
                        <Pen fill="color_purple" width="14px" height="14px" />
                      </MobileCreditEditButton>
                    )}
                  </MobileCreditTitleRow>
                  <StyledLineMobile>{this.renderMobileCreditEditor()}</StyledLineMobile>
                </BaseColumn>
              </StyledRowMobile>
            </>
          )}
        </StyledCardBody>
      </StyledCard>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      selectEmployeeCredit,
      onUpdateEmployeeCredit,
      changeEmployeeCredit
    },
    dispatch
  );

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  editMode: state.clientsTable.employees.editableRow === ownProps.id
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersRow);
